module.exports = __webpack_public_path__ + "media/svg-new/online-test-c01a99b3.svg";